// extracted by mini-css-extract-plugin
module.exports = {"list":"OrdersList_list__1CJfM","statusesFilter":"OrdersList_statusesFilter__2i8Ym","status":"OrdersList_status__396iw"};